import {Anchor, createTopAnchor} from '@cypro/ui/components/ui/infinite-data-table'
import {queries} from '@/shared/integrations/zero'
import {ListCategoriesInput} from '@cypro/engine/queries'
import {DrugsCategory} from '@cypro/engine/schema'
import {useQuery} from '@rocicorp/zero/react'
import {useEffect, useState} from 'react'

export function useGetDrugsCategories({
  sort = {dir: 'asc', field: 'name'},
  filters,
  limit,
}: Omit<Partial<ListCategoriesInput>, 'cursor'> = {}) {
  const [anchor, setAnchor] = useState<Anchor<DrugsCategory>>(createTopAnchor<DrugsCategory>())

  const cursor =
    anchor.startRow?.id && anchor.startRow?.createdAt
      ? {
          id: anchor.startRow.id,
          direction: anchor.direction,
          createdAt: anchor.startRow.createdAt,
          name: anchor.startRow.name,
        }
      : undefined

  const query = queries.basicData.listDrugsCategories({
    cursor,
    sort,
    filters: {status: ['active'] as const, ...filters},
    limit,
  })
  const [categories, meta] = useQuery(query)

  useEffect(() => {
    setAnchor(createTopAnchor<DrugsCategory>())
  }, [sort?.dir, sort?.field, filters?.search, limit])

  return {
    query,
    meta,
    categories,
    anchor,
    fetchMore: setAnchor,
    canFetchMore: categories.length === limit,
    isFetching: meta.type === 'unknown',
  }
}
